import { AccessPermissionRole } from "@core-services/data-types"

export const accessPermissionRoleMapping: Record<AccessPermissionRole, string> = {
  [AccessPermissionRole.Administrator]: "Administrator",
  [AccessPermissionRole.ChannelManager]: "Channel manager",
  [AccessPermissionRole.User]: "User",
}
